import global from "@/locales/es-ES/global";
import error403 from "@/locales/es-ES/errors/403";
import error404 from "@/locales/es-ES/errors/404";
import error500 from "@/locales/es-ES/errors/500";
import error503 from "@/locales/es-ES/errors/503";
import error504 from "@/locales/es-ES/errors/504";
import maintenance from "@/locales/es-ES/auth/maintenance";
import toast from "@/locales/es-ES/toast/toast";
import login from "@/locales/es-ES/auth/login";
import onboarding from "@/locales/es-ES/auth/onboarding";
import loginPageSteps from "@/locales/es-ES/loginPageSteps";
import dashboard from "@/locales/es-ES/dashboard/dashboard";
import account from "@/locales/es-ES/account/account";
import mailbox from "@/locales/es-ES/account/mailbox";
import bankstatement from "@/locales/es-ES/account/bankstatement";
import myApps from "@/locales/es-ES/my-apps/myApps";
import about from "@/locales/es-ES/about/about";
import contactService from "@/locales/es-ES/about/contactService";
import salesPromotions from "@/locales/es-ES/sales/promotions";
import brochures from "@/locales/es-ES/sales/brochures";
import shop from "@/locales/es-ES/shop/data";
import priceList from "@/locales/es-ES/shop/priceList";
import staff from "@/locales/es-ES/dashboard/staff";
import promotions from "@/locales/es-ES/promotions";
import points from "@/locales/es-ES/points";
import trainings from "@/locales/es-ES/trainings/trainings";
import vouchers from "@/locales/es-ES/vouchers/vouchers";
import media from "@/locales/es-ES/media/index";
import product from "@/locales/es-ES/product/index";
import message from "@/locales/es-ES/message/index";
import commitmentLetter from "@/locales/es-ES/account/commitmentLetter";
import multiplicator from "@/locales/es-ES/multiplicator";
import widgets from "@/locales/es-ES/widgets/widgets";
import consents from "@/locales/es-ES/consents/consents";
import investment from "@/locales/es-ES/investment/data";
import kickback from "@/locales/es-ES/kickback";

//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Imágenes de productos",
    BDriveLinkText: "Enlace al portal de IMÁGENES DE PRODUCTOS",
  },
}

export default {
  locale: "es-ES",
  messages,
};
